import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import SignaturePad from '../components/SignaturePad';
import '../styles/HptScreens.css';
import Swal from 'sweetalert2';
import PermisoEscalera from '../components/PermisoEscalera';

// BackEnd de Serveless
const API_URL = process.env.REACT_APP_API_URL;

// ============================================================================
// COMPONENTE: ExpandableCard (Acordeón reutilizable)
// ============================================================================
const ExpandableCard = ({ title, icon, children }) => {
    const [isOpen, setIsOpen] = useState(false); //Estado para comprobar si está ab|ce
    return (
        <div className="expandable-card">
            <div className="card-header" onClick={() => setIsOpen(!isOpen)}>
                <span>{icon} {title}</span>
                <span>{isOpen ? '▲' : '▼'}</span>
            </div>
            {/* Si isOpen es true, se añade clase 'open' (display: block) */}
            <div className={`card-content ${isOpen ? 'open' : ''}`}>
                {children}
            </div>
        </div>
    );
};

// ============================================================================
// COMPONENTE PRINCIPAL: CreateHPTScreen
// ============================================================================
const CreateHPTScreen = () => {
    const navigate = useNavigate(); // Redireccion a otras pantallas
    const location = useLocation(); // Capturar el estado de la navegacion

    // --- ESTADOS DE DATOS (CATÁLOGOS DEL SERVIDOR) ---
    const [localizaciones, setLocalizaciones] = useState([]); // Localizaciones
    const [usuarios, setUsuarios] = useState([]);             // Listado de Usuarios
    const [catalogo, setCatalogo] = useState([]);             // Catalogos de Riesgos y medidas

    // --- ESTADOS DEL FORMULARIO PRINCIPAL ---
    const [seleccionados, setSeleccionados] = useState([]);   // IDs riesgos marcados. Array
    const [trabajadores, setTrabajadores] = useState([]);     // Array de listado de Trabajadores
    const [materiales, setMateriales] = useState([]);         // Array de materiales
    const [recursos, setRecursos] = useState([]);             // Array de Energías y Trabajos Previos
    const [imagenesBase64, setImagenesBase64] = useState([]); // Fotos subidas, convertidas a texto Base64
    const [archivosPendientes, setArchivosPendientes] = useState([]); // Archivos PDF's, Excel
    const [plantillaActiva, setPlantillaActiva] = useState("vacio"); // Plantillas Predefinidas

    // --- Añadido a Riesgos Maquinaria Medida Otros
    const [detallesRiesgos, setDetallesRiesgos] = useState({});


    // --- ESTADOS DEL BUSCADOR AUTOCOMPLETAR (ACTIVOS) ---
    const [busquedaActivo, setBusquedaActivo] = useState('');     // Texto a Escribir por el usuario
    const [mostrarDesplegable, setMostrarDesplegable] = useState(false); // MUestra resultados en columna
    const [opcionesActivos, setOpcionesActivos] = useState([]);   // Resultados de la búsqueda desde el servidor

    // --- Para autocompletar bloques de usuarios ---
    const [busquedaUsuarios, setBusquedaUsuarios] = useState('');
    const [mostrarDesplegableUsuarios, setMostrarDesplegableUsuarios] = useState(false);
    const [opcionesUsuarios, setOpcionesUsuarios] = useState([]);
    

    // --- Control de botones de guardado
    const [accionSubmit, setAccionSubmit] = useState('sign');
    const [showSignature, setShowSignature] = useState(false);// Mostrar|Ocultar panel de firmas

    // -- Estado de bloqueo de doble Envio
    const [estaGuardando, setSeEstaGuardando] = useState(false);

    // --- Control del Anexo de Escalera ---
    const [showEscaleraModal, setShowEscaleraModal] = useState(false);
    const [datosEscalera, setDatosEscalera] = useState(null);

    // --- Catalogos Eléctricos ---
    const [electricosBloqueo, setElectricosBloqueo] = useState([]);
    const [electricosDescargo, setElectricosDescargo] = useState([]);
    // --- Tablas de Maniobra asignadas a la HPT ---
    const [bloqueosElectricos, setBloqueosElectricos] = useState([]);
    const [descargosElectricos, setDescargosElectricos] = useState([]);

    // Capturamos el id de la planta enviado por el Dashboard, con un fallback seguro
    const idPlantaActiva = location.state?.id_planta || '';

    // --- ESTADO CENTRAL DEL FORMULARIO (Campos base) ---
    const [formData, setFormData] = useState({
        id_planta: idPlantaActiva,
        titulo: '',
        ot_referencia: '',
        id_activo: '',
        den_act_descripcion: '',
        descripcion_trabajo: '',
        operarios_previstos: '',    
        duracion_prevista_hours: '',
        fecha_prevista: '',
        horario_previsto: '',
        id_localizacion: '',
        interviene_subcontrata: false,
        id_usuario_subcontrata: null,
        preventivos: [],
        tipo_incidencia: 'PREVENTIVO', 
        dias_previstos: '',
        id_st: ''
    });

    // --- CONFIGURACIÓN MAPEADA ---
    // Categorías de recursos y trabajos previos para generar los checkboxes en pantalla
    const CONFIG_RECURSOS = {
        'EQUIPO ESPECIAL': ['Andamiero', 'Calorifugador', 'Soldador', 'ENDs', 'Mecanizado', 'Grup. Electrógeno', 'Compresor', 'Luminarias'],
        'ACCESO': ['Andamio / Andamio taller', 'Plataforma elevadora', 'Anticaídas Retráctiles', 'Línea de vida', 'Banqueta/alfombra', 'Escalera', 'Pescante/tripode'],
        'ENERGÍA TRABAJO': ['Agua', 'N2', 'Argon', 'Aire', 'Electricidad', 'Gasolina/Gasoil'],
        'ENERGÍA EQUIPO': ['HTF', 'Agua', 'Vapor', 'Químicos', 'Nitrógeno', 'Electrica', '75v CC/50v CA'],
        'TRABAJOS PREVIOS': ['Enclavamiento eléctrico', 'Descargo eléctrico', 'Descargo mecánico', 'Doble Verificación', 'Despresurizar', 'Drenar', 'PCI Fuera de Servicio', 'Inertizar (N2)', 'INERTIZAR CON VAPOR', 'VENTEO', 'LAVADO DE LÍNEAS', 'SEÑALES FORZADAS DCS', 'EQUIPOS EN TAGOUT', 'DESCARGO LOCs', 'Levantamiento en pruebas']
    };

    // --- Plantillas Predefinidas --- //
    const PLANTILLAS_PREDEFINIDAS = [
        {
            id: "vacio",
            nombre: "-- Crear desde cero --",
            titulo: "",
            codigos_riesgos: [],
            recursos: [],
            descripcion_trabajo: '',
            duracion_prevista_hours: '',
            operarios_previstos: '',
            materiales: []
        },
        {
            id: "acumuladores_turbina",
            nombre: "Acumuladores de Turbina",
            titulo: "Revisión de Acumuladores",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.5", "1.9", "1.10", "11", "11010"], 
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Nitrógeno'},
                {cat: "TRABAJOS PREVIOS", nom: 'Descargo mecánico'},
                {cat: "TRABAJOS PREVIOS", nom: 'Despresurizar'}
            ],
            materiales: [],
            duracion_prevista_hours: "1",
            operarios_previstos: "2",
            descripcion_trabajo: "COMPROBAR PRESIÓN DE NITRÓGENO EN ACUMULADORES.\nSE REALIZARA COMPROBACIÓN DE PRESIÓN DE LOS ACUMULADORES Y SI FUESE NECESARIO SE AJUSTARA CON NITRÓGENO A LA PRESIÓN CORRESPONDIENTE."
        },
        {
            id: "filtros_captacion",
            nombre: "Filtro Captación",
            titulo: "Limpieza Filtro Captación",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.5", "1.9", "1.10", "11", "11010"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Agua'},
                {cat: "TRABAJOS PREVIOS", nom: 'Descargo mecánico'},
                {cat: "TRABAJOS PREVIOS", nom: 'Despresurizar'},
                {cat: "TRABAJOS PREVIOS", nom: 'Drenar'}
            ],
            materiales: [],
            duracion_prevista_hours: "2",
            operarios_previstos: "2",
            descripcion_trabajo: "SE REALIZARA LIMPIEZA DE FILTRO."
        },
        {
            id: "aceite_vg",
            nombre: "Aceite VG 46 08",
            titulo: "Cambio Aceite VG 46",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.5", "1.9", "1.10", "11", "11010", "6", "6005", "6006"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Químicos', detalle: 'Aceite'},
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento eléctrico'}
            ],
            materiales: [
                { descripcion: "ACEITE VG 46", unidades: "", almacen: "1AC0064" }
            ],
            duracion_prevista_hours: "1",
            operarios_previstos: "2",
            descripcion_trabajo: "- CAMBIO LUBRICANTE.\n1. DRENAR LUBRICANTE\n2. COMPROBAR LUBRICANTE DRENADO\n- REPONER LUBRICANTE\n- GESTIONAR RESIDUOS"
        },
        {
            id: "acumuladores_pci",
            nombre: "Acumuladores PCI",
            titulo: "Inspección Acumuladores PCI",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.9", "1.10", "11", "11010"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Agua'},
                {cat: "ENERGÍA TRABAJO", nom: 'Aire'},
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento mecánico'},
                {cat: "TRABAJOS PREVIOS", nom: 'Despresurizar'},
                {cat: "TRABAJOS PREVIOS", nom: 'Drenar'}
            ],
            materiales: [],
            duracion_prevista_hours: "1",
            operarios_previstos: "2",
            descripcion_trabajo: "- INSPEC VIS ACUMULADOR HIDRONEUMATICO.\n-COMPROBAR PRESION\nREALIZAR LLENADO SI ES NECESARIO\nLA PRESION DEBE SER DE 6.7 BAR."
        },
        {
            id:"alineacion",
            nombre: "Alineación",
            titulo: "Revisión de Alineación",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.5", "1.9", "1.10", "11", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'},
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento eléctrico'}
            ],
            materiales: [
                { descripcion: "ALINEADORA EASY LASER E530 Nº  SERIE 83759 ", unidades: "", almacen: "" }
            ],
            duracion_prevista_hours: "1",
            operarios_previstos: "2",
            descripcion_trabajo: "REVISIÓN DE ALINEACIÓN.\n- RETIRADA DE CUBRE ACOPLAMIENTO.\n- COLOCAR EN AMBOS EJES ESTACIONES DE MEDICIÓN.\n- REALIZAR MEDICIÓN EN TRES PUNTOS.\n- COMPROBAR QUE LOS RESULTADOS ESTÁN DENTRO DE LOS PARÁMETROS DADOS POR EL FABRICANTE.\n- MONTAR CUBRE ACOPLAMIENTO."
        },
        {
            id: "cambio_aceite_deflectores",
            nombre: "Cambio de Aceite y Revisión de deflectores",
            titulo: "Cambio de Aceite y Revisión de deflectores",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.5", "1.9", "1.10", "11", "11010"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Agua'},
                {cat: "ENERGÍA EQUIPO", nom: 'Químicos', detalle: 'Aceite'},
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento eléctrico'}
            ],
            materiales: [
                { descripcion: "ACEITE VG 46", unidades: "", almacen: "1AC0064" }
            ],
            duracion_prevista_hours: "1",
            operarios_previstos: "2",
            descripcion_trabajo: "- CAMBIO LUBRICANTE.\n1. DRENAR LUBRICANTE\n2. COMPROBAR LUBRICANTE DRENADO\n- REPONER LUBRICANTE\n- GESTIONAR RESIDUOS\n- REVISION DE DEFLECTORES"
        },
        {
            id: "clarificadora",
            nombre: "Conos Clarificadora",
            titulo: "Limpieza Conos Clarificadora",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.5", "1.9", "1.10", "6", "6005", "6006", "11", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOSO", nom: 'Descargo mecánico'},
                {cat: "ENERGÍA EQUIPO", nom: 'Químicos', detalle: 'Aceite'},
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento eléctrico'}
            ],
            materiales: [],
            duracion_prevista_hours: "4",
            operarios_previstos: "2",
            descripcion_trabajo: "SE REALIZARA LIMPIEZA DE CONOS DE LA CLARIFICADORA.\nSE REALIZARA REVISIÓN DE NIVELES Y LIMPIEZA DEL EQUIPO."
        },
        {
            id: "correas_gland_condenser",
            nombre: "Correas Gland Condenser",
            titulo: "Sustitución Correas Gland Condenser",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3","1.4", "1.5", "1.9", "1.10", "11", "11010"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Vapor'},
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'},
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento eléctrico'}
            ],
            materiales: [
                { descripcion: "CORREA SPA 2082", unidades: "", almacen: "6C00004" }
            ],
            duracion_prevista_hours: "2",
            operarios_previstos: "2",
            descripcion_trabajo: "CAMBIO DE CORREAS-DESMONTAR PROTECCIONES.\n-DESTENSAR Y QUITAR CORREAS USADAS.\n-MONTAR CORREAS NUEVAS.\n-TENSAR Y COMPROBAR ALINEACION DE LAS POLEAS.\n-MONTAR PROTECCIONES.\n-COMPROBAR FUNCIONAMIENTO."
        },
        {
            id: "engrase_ventiladores_tv",
            nombre: "Engrase Ventiladores TV",
            titulo: "Engrase Ventiladores TV",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.5", "1.9", "1.10","6", "6001", "11", "11010"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Eléctrica'},
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento eléctrico'}
            ],
            materiales: [],
            duracion_prevista_hours: "1",
            operarios_previstos: "2",
            descripcion_trabajo: "SE REALIZARA ENGRASE DE MOTOR ELÉCTRICO."
        },
        {
            id: "trabajos_varios_lazos",
            nombre: "Trabajos Varios en Lazo por Fallo",
            titulo: "Trabajos Varios en Lazo por Fallo",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.4", "1.9", "1.10","2", "2005", "2006", "9", "9002", "9003", "9005", "10", "10001", "10002", "11", "11003", "11004", "11005", "11006", "11007", "11008", "11009", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Trabajos varios en lazo por fallos.\n-Limpieza electroválvulas de corte y chicles\nRearme de lazos en CS\nCambio de baterías en armarios de CS\nCalibrado de lazos en CS\nRecarga de N2 de acumulador de CS\nCambio de Bombas Hidráulicas\nCambio de repartidores por fisuras\nCambio de PT100\nTrabajos que no conllevan ningun riesgo eléctrico"
        },
        {
            id: "tirar_hce_rotos_limpieza_espejos",
            nombre: "Tirar HCE ROTOS y Limpieza Espejos Rotos",
            titulo: "Limpieza HCE y Espejos Rotos",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.4", "1.9", "1.10", "9", "9002", "9005", "11", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Se pedirá lazo a Sala de Control a -15º. \nUna vez en posición se colocarán EPIs, pondremos manta en el suelo.\nTiramos el HCE al suelo y recogemos los cristales Rotos"
        },
        {
            id: "radiografiado_hce_ball_joint_liquidos_penetrantes",
            nombre: "Radiografiado HCE, BALL JOINT y Liquidos Penetrantes",
            titulo: "Radiografiado HCE, BALL JOINT y Liquidos Penetrantes",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001","1004", "1005", "1.2", "1.3", "1.4", "1.6", "1.7", "1.9", "1.10", "1.14","2", "2003", "2005", "2006", "9", "9002", "9005", "10", "10002", "10006", "11", "11003", "11004", "11005", "11006", "11009", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Radiografiado de soldaduras y líquidos penetrantes de campo solar. \nTrabajos a realizar por APPLUS fuera de horario de Mantenimiento.\n R.P. JT/OC Indistintamente.\nFuera de Horario de mantenimiento Rellenar autorización de entrega y recogida de maquinaria APPLUS utilizará plataforma remolque de AMEXOL.\nAportar Radio a APPLUS para realizar doble verificación"
        },
        {
            id: "mantenimiento_lazo",
            nombre: "Mantenimiento Lazo",
            titulo: "Mantenimiento Lazo CS",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1003", "1004", "1005", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7", "1.9", "1.10","2", "2003", "2005", "2006", "6", "6001", "6002", "6003", "6005", "6007", "9", "9002", "9005", "11", "11003", "11004", "11005", "11006", "10007", "10008", "11009", "11010"],
            recursos: [
                {cat: "EQUIPO ESPECIAL", nom: 'Calorifugador'},
                {cat: "ACCESO", nom: 'Plataforma Elevadora'},
                {cat: "ENERGÍA TRABAJO", nom: 'N2'},
                {cat: "ENERGÍA TRABAJO", nom: 'Aire'},
                {cat: "TRABAJOS PREVIOS", nom: 'Descargo eléctrico'},
                {cat: "TRABAJOS PREVIOS", nom: 'Descargo mecánico'},
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'},
                {cat: "TRABAJOS PREVIOS", nom: 'Despresurizar'},
                {cat: "TRABAJOS PREVIOS", nom: 'Drenar'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Trabajos de mantenimiento de lazos.\nGrafitado\nLimpieza con Drive Pylon\nLimpieza de cajas de aislamientos\nEngrases de Drive Pylon, Válvulas\nCambio de abarcones y de Sill"
        },
        {
            id: "inspeccion_legal_c",
            nombre: "Inspección Legal Nivel C",
            titulo: "Inspección Legal C (Lazo)",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001","1002", "1004", "1005", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7", "1.9", "1.10","2", "2006", "9", "9002","11", "11001", "11003", "11004", "11005", "11006", "10007", "10008", "11009", "11010"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'HTF'},
                {cat: "ENERGÍA TRABAJO", nom: 'N2'},
                {cat: "ENERGÍA TRABAJO", nom: 'Aire'},
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'},
                {cat: "TRABAJOS PREVIOS", nom: 'Despresurizar'},
                {cat: "TRABAJOS PREVIOS", nom: 'Drenar'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Se realizará revisión Nivel C en LAZO.\nLas pruebas consisten en tarado de la PSV a baja temperatura, medida de espesores\nRevisión ausencia de Fugas\nPrueba de presión según PSV con aislamiento y drenaje de la misma parte de CS\nSe hará con caja de consignaciones portatil con la planta estable con cuando mejor se adapta a la planta\nAl finalizar se dejará alineado todo a operación"
        },
        {
            id: "fallo_pt100",
            nombre: "Fallo PT100",
            titulo: "Revisión Fallo PT100",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001","1003", "1.2", "1.3", "1.4", "1.5", "1.9", "1.10", "1.11", "2", "2005", "2006",  "9", "9002", "9005", "11","11006", "10007", "11009", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Fallo en PT100.\nSe procederá con el lazo a 180º, sino se puede hacer antes de la salida del sol\nPulsar seta de emergencia, guardamotor y extraer fusibles\nSe desconectará la baina de la sonda y meteremos el cable uno contra otro para tirar del viejo y meter el nuevo por el tubo\nDesconectar cable viejo y conectar el nuevo"
        },
        {
            id: "cambio_placa_muelle",
            nombre: "Cambio de Placas Muelles",
            titulo: "Cambio Placas Muelles",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001","1004", "1.2", "1.3", "1.5", "1.6", "1.7", "1.8", "1.9", "1.10", "1.11", "1.17", "2", "2003", "2005", "2006",  "9", "9002", "9005", "10", "10001", "10002", "11", "11003", "11004", "11005", "11006", "11009", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Descargo eléctrico'},
                {cat: "TRABAJOS PREVIOS", nom: 'Descargo mecánico'},
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'},
                {cat: "TRABAJOS PREVIOS", nom: 'Despresurizar'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Cambio de Placa Muelles.\nSe cambiará la placa muelle rota con descargo mecánico y eléctrico"
        },
        {
            id: "cambiar_calorifugado",
            nombre: "Cambio de Calorifugado",
            titulo: "Sustitución Calorifugado",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.6", "1.9", "1.10", "9", "9002", "9005","11", "11006", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Cambio de Calorifugado.\nSe procederá a colocar el nuevo calorifugado\nSe retirará los restos del viejo calorifugado\nSe pedirá por mantenimiento el lazo a posición indicada y se pulsará seta de emergencia\nVerificar orden de no marcha."
        },
        {
            id: "espejos_rotos",
            nombre: "Cambio de Espejos Rotos",
            titulo: "Cambio de Espejos Rotos",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001","1003", "1.2", "1.3", "1.4", "1.6", "1.9", "1.10", "1.11", "2", "2006", "9", "9002", "9005", "11", "11003", "11004", "11005", "11006", "11010"],
            recursos: [
                {cat: "ACCESO", nom: 'Escalera'},
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Espejos Rotos.\nMantenimiento pedirá la posición del lazo\nPulsará la seta de emergencia y verificar orden de no marcha."
        },
        {
            id: "cambio_latiguillo_cs",
            nombre: "Cambio de Latiguillos en CS",
            titulo: "Sustitución Latiguillos CS",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001","1004", "1.2", "1.3", "1.5", "1.6", "1.9", "1.10", "1.11", "1.17", "9", "9002", "9005", "11", "11006", "11007", "11010"],
            recursos: [
                {cat: "ACCESO", nom: 'Escalera'},
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Se sustituiran latiguillos por pequeñas fugas de GH en CS.\nPulsaremos Seta Emergencia y guardamotor\nSe quitará presión en GH"
        },
        {
            id: "cambio_repartidores_cs",
            nombre: "Cambio de Repartidores de CS",
            titulo: "Cambio Repartidores CS",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.2", "1.3", "1.4", "1.9", "1.10", "2", "2006",  "9", "9005",  "11", "11003", "11004", "11005", "11006", "11007", "11008", "11009", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'},
                {cat: "TRABAJOS PREVIOS", nom: 'Despresurizar'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Cambio de repartidores en CS.\nSe pulsará Seta de Emergencia y guardamotor\nSe despresurizará el repartidor\nSe desmontará repartirtodor viejo y se pondra el nuevo\nReponer descargo y comprobar que todo vaya bien."
        },
        {
            id: "limpieza_espejos_cs",
            nombre: "Limpieza espejos Campo Solar",
            titulo: "Limpieza espejos Campo Solar",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1004", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7", "1.9", "1.10", "1.17", "2", "2006",  "9", "9005", "10", "10001",  "11", "11001", "11003", "11004", "11005", "11006", "11007", "11008", "11009", "11010"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'},
                {cat: "ENERGÍA TRABAJO", nom: 'Gasolina/Gasoil'},
                {cat: "ENERGÍA TRABAJO", nom: 'Agua'},
                {cat: "ENERGÍA EQUIPO", nom: 'Agua'},
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "SE PROCEDERA A MANDAR LOS LAZOS A POSICION DE LIMPIEZA UNA VEZ TERMINE SE MANDAN A SEGUIMIENTO,LLENADO DE CUBA "
        },
        {
            id: "descargo_trafo_no_generacion",
            nombre: "Descargo Trafo No generacion",
            titulo: "Descargo de Transformador de No Generación",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.18", "1.19", "5", "5003", "5004", "5005", "5006", "5007", "5008", "5009", "5010", "5011"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Descargo eléctrico'}
            ],
            materiales: [],
            duracion_prevista_hours: "4",
            operarios_previstos: "2",
            descripcion_trabajo: "1. Localización del equipo.\n2. Maniobras eléctricas (bloqueos o descargos) \n3. Realización del trabajo\n4.Vuelta al estado inicial\nEl descargo repercute en la no generación, operación deberá cambiar de barras "
        },
        {
            id: "test_electrico",
            nombre: "Test Eléctrico",
            titulo: "Test Eléctrico",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.18", "1.19", "5", "5005", "5006", "5007", "5008", "5009", "5010", "5011"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento eléctrico'},
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'}
            ],
            materiales: [],
            duracion_prevista_hours: "2",
            operarios_previstos: "2",
            descripcion_trabajo: "1. Localización del equipo.\n2. Maniobras Pertinentes\n3. Realizar el trabajo\n4. Volver a su estado inicial."
        },
        {
            id: "sustitución_filtros_vf",
            nombre: "Sustitución de Filtros VF",
            titulo: "Sustitución de Filtros VF",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1.19"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Enclavamiento eléctrico'}
            ],
            materiales: [],
            duracion_prevista_hours: "2",
            operarios_previstos: "2",
            descripcion_trabajo: "1. Localización del equipo.\n2. Desconexión del Equipo\n3. Sustituir los Filtros\n4. Dejar en Servicio."
        },
        {
            id: "desbroce_planta",
            nombre: "Desbroce de Planta",
            titulo: "Desbroce de Planta y tratamiento de Herbicida",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1004", "1.2", "1.3", "1.4", "1.5", "1.6", "1.7",  "1.9", "1.10", "1.11", "1.17", "2", "2006", "9", "9002", "9005", "10", "10001", "10007", "11001", "11003", "11004", "11005", "11006", "11008", "11010", "11009"],
            recursos: [
                {cat: "TRABAJOS PREVIOS", nom: 'Doble Verificación'},
                {cat: "ENERGÍA EQUIPO", nom: 'Gasolina/Gasoil'}
            ],
            materiales: [],
            duracion_prevista_hours: "40",
            operarios_previstos: "2",
            descripcion_trabajo: "Desbroce de toda la planta. Se realizan desbroces con la desbrozadora de mano en lugares que no pueda acceder el tractor. Con el tractor se desbrozará donde pueda acceder.\nComprobación de no arranque a los lazos que se encuentren en la zona donde se va a desbrozar."
        },
        {
            id: "descarga_gnl",
            nombre: "Descarga GNL",
            titulo: "DESCARGA DE CISTENA DE GNL",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1002", "1003", "1.5", "1.6", "1.8", "1.9", "1.10", "1.11", "1.15", "6", "6001", "6002", "6007", "7", "7001", "7002", "7008", "7009", "10", "10007", "10008", "110001"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Químicos', detalle: "GNL"}
            ],
            materiales: [],
            duracion_prevista_hours: "3",
            operarios_previstos: "2",
            descripcion_trabajo: "Se realizará descarga de cisterna de GNL en tanques 5025-V-001A/B. La empresa encargada de realizar ls trabajos será MOLGÁS. Se designa como recurso preventivo permanente de este trabajo al Operador que esté en el turno, o en su defecto al Jefe de Turno."
        },
        {
            id: "descarga_n2",
            nombre: "Descarga Nitrógeno",
            titulo: "DESCARGA DE CISTENA DE Nitrógeno",
            tipo_incidencia: "PREVENTIVO",
            codigos_riesgos: ["1001", "1002", "1003",  "1.6", "1.9", "1.10", "1.11", "1.15",  "6", "6001", "6007", "10", "10001", "10007", "10008", "110001"],
            recursos: [
                {cat: "ENERGÍA EQUIPO", nom: 'Nitrógeno'}
            ],
            materiales: [],
            duracion_prevista_hours: "3",
            operarios_previstos: "2",
            descripcion_trabajo: "Se realizará descarga de cisterna de N2 en tanque 5050-V-001. La empresa encargada de realizar ls trabajos será NIPPON GASES. Se designa como recurso preventivo permanente de este trabajo al Operador que esté en el turno, o en su defecto al Jefe de Turno."
        },
    ];

    // ============================================================================
    //  IDENTIFICACIÓN DEL USUARIO LOGUEADO (Síncrono)
    // ============================================================================
    const token = localStorage.getItem('userToken');
    let currentUser = {};
    let nombreUsuarioCompleto = 'Usuario Desconocido';

    if (token) {
        try {
            currentUser = JSON.parse(atob(token.split('.')[1]));
            // Extraemos el nombre completo para las firmas
            nombreUsuarioCompleto = `${currentUser.nombre || ''} ${currentUser.apellidos || ''}`.trim() || currentUser.user_name || 'Usuario';
        } catch(e) { 
            console.error("Error leyendo token"); 
        }
    }

    // ============================================================================
    //  Efectos al montar Componente.
    // ============================================================================
    useEffect(() => {
        // Carga Localizaciones, Usuarios y Catálogo de Riesgos desde la base de datos
        const userRol = currentUser.rol || '';
        const token = localStorage.getItem('userToken');
        const config = { headers: { Authorization: `Bearer ${token}` } };

        const rolAutorizado = ['ADMINISTRADOR', 'PREVENCION', 'GESTOR', 'SUPERVISOR', 'JEFE_TURNO', 'OFICIAL'];
        if (userRol && !rolAutorizado.includes(userRol)) {
            Swal.fire("Acceso denegado", "No tienes permiso para estar aquí", "error");
            navigate('/dashboard');
        }
        
        const fetchData = async () => {
            try {
                // Para asegurar velocidad hacemos las tres peticiones a la vez
                const [resLocs, resUsers, resCatalogo, resElectricosBloqueo, resElectricosDescargo] = await Promise.all([
                    axios.get(`${API_URL}/api/catalogos/localizaciones?planta=${idPlantaActiva}`, config),
                    axios.get(`${API_URL}/api/catalogos/usuarios`, config),
                    axios.get(`${API_URL}/api/catalogos/seguridad`, config),
                    axios.get(`${API_URL}/api/catalogos/electricosBloqueo?planta=${idPlantaActiva}`, config),
                    axios.get(`${API_URL}/api/catalogos/electricosDescargo?planta=${idPlantaActiva}`, config)
                ]);
                
                // Cloudflare a veces devuelve data directa y a veces data.results. 
                const extractData = (res) => res.data.results ? res.data.results : res.data;

                setLocalizaciones(extractData(resLocs));
                setUsuarios(extractData(resUsers));
                setCatalogo(extractData(resCatalogo));
                setElectricosBloqueo(extractData(resElectricosBloqueo));
                setElectricosDescargo(extractData(resElectricosDescargo));
            } catch (err) { console.error("Error cargando catálogos:", err); }
        };
        fetchData();
    }, [idPlantaActiva]);

    // ============================================================================
    // FUNCIONES: BUSCADOR DE ACTIVOS (AUTOCOMPLETAR)
    // ============================================================================
    // Se ejecuta al escribir en el campo "codigo activo"
    const buscadorTimeout = useRef(null);
    const buscarActivosEnServidor = async (texto) => {
        setBusquedaActivo(texto);

        if (buscadorTimeout.current) {
            clearTimeout(buscadorTimeout.current);
        }
        
        // Al menos tres letras, para realizar peticiones al servidor
        if (texto.length < 3) {
            setOpcionesActivos([]);
            return;
        }

        // Tiempo de espera para el disparador
        buscadorTimeout.current = setTimeout(async () => {
            try {
                const token = localStorage.getItem('userToken');
                const res = await axios.get(`${API_URL}/api/catalogos/activos/buscar?q=${texto}&planta=${idPlantaActiva}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                
                // Guardamos los resultados optimizados
                setOpcionesActivos(res.data.results || []);
            } catch (err) {
                console.error("Error buscando activos en el catálogo:", err);
            }
        }, 350);
    };
    // Al hacer clic en una opción de la lista desplegable
    const seleccionarActivo = (activo) => {
        setFormData({
            ...formData,
            id_activo: activo.id_activo,
            den_act_descripcion: activo.denominacion // Rellena el campo de sólo lectura
        });
        setBusquedaActivo(activo.codigo_activo); // Deja el código en el input
        setMostrarDesplegable(false); // Cierra la lista
    }

    // ============================================================================
    // FUNCIONES: BUSCADOR DE USUARIOS (AUTOCOMPLETAR)
    // ============================================================================
    // Se ejecuta al escribir en el campo "codigo activo"
    const buscarUsuariosServidor = async (texto) => {
        setBusquedaUsuarios(texto);
        
        // Al menos tres letras, para realizar peticiones al servidor
        if (texto.length < 2) {
            setOpcionesUsuarios([]);
            return;
        }

        try {
            const token = localStorage.getItem('userToken');
            const res = await axios.get(`${API_URL}/api/catalogos/usuarios/buscar?q=${texto}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            // Guarda los resultados en el estado para mostrarlos en la lista desplegable
            setOpcionesUsuarios(res.data.results || []);
        } catch (err) {
            console.error("Error buscando usuarios:", err);
        }
    };

    // Al hacer clic en la opción del usuario por departamento
    

    const seleccionarListaUsuarios = (g) => {
        const arrayUsuarios = g.lista_usuarios ? g.lista_usuarios.split(', ') : [];
        setFormData({
            ...formData,
            preventivos: g.lista_usuarios ? [g.lista_usuarios] : []
        });
        setBusquedaUsuarios(`${arrayUsuarios}`);
        setMostrarDesplegableUsuarios(false);
    };

    // ============================================================================
    // FUNCIONES: GESTIÓN DE MATERIALES / REPUESTOS
    // ============================================================================
    // Añade fila vacia en la tabla de materiales
    const addMaterial = () => setMateriales([...materiales, { descripcion: '', unidades: '', almacen: '' }]);
    
    // Actualiza el texto de una celda específica en la tabla de materiales
    const updateMaterial = (idx, field, val) => {
        const newM = [...materiales];
        newM[idx][field] = val;
        setMateriales(newM);
    };


    // ============================================================================
    // FUNCIONES: GESTIÓN DE BLOQUEOS ELÉCTRICOS (LOTO)
    // ============================================================================
    const addBloqueoElectrico = () => {
        const numAleatorio = Math.floor(Math.random() * 999999) + 1;
        setBloqueosElectricos([...bloqueosElectricos, {
            num_consignacion: numAleatorio,
            id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '',
            textoBusqueda: '', mostrarDesplegable: false
        }]);
    };

    const removeBloqueoElectrico = (idx) => {
        setBloqueosElectricos(bloqueosElectricos.filter((_, i) => i !== idx));
    };

    const handleFilaBloqueoChange = (idx, texto) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx].textoBusqueda = texto;
        nuevasFilas[idx].mostrarDesplegable = texto.length >= 2;
        // Si borra el texto, limpiamos el bloqueo seleccionado
        if (texto === '') {
            nuevasFilas[idx].activo = '';
            nuevasFilas[idx].centro_cargas = '';
            nuevasFilas[idx].ubicacion = '';
            nuevasFilas[idx].tension = '';
            nuevasFilas[idx].descripcion = '';
        }
        setBloqueosElectricos(nuevasFilas);
    };

    const toggleBloqueoDesplegable = (idx, visible) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx].mostrarDesplegable = visible && nuevasFilas[idx].textoBusqueda.length >= 2;
        setBloqueosElectricos(nuevasFilas);
    };

    const seleccionarElementoBloqueoElectrico = (idx, elemento) => {
        const nuevasFilas = [...bloqueosElectricos];
        nuevasFilas[idx] = {
            ...nuevasFilas[idx],
            id_item: elemento.id_item,
            activo: elemento.activo,
            centro_cargas: elemento.centro_cargas || 'S/C',
            ubicacion: elemento.ubicacion || 'S/U',
            tension: elemento.tension,
            descripcion: elemento.descripcion || '',
            textoBusqueda: elemento.activo, // Dejamos el Tag visible en el input
            mostrarDesplegable: false // Cerramos su desplegable
        };
        setBloqueosElectricos(nuevasFilas);
    };



    // ============================================================================
    // FUNCIONES: GESTIÓN DE BLOQUEOS ELÉCTRICOS (LOTO)
    // ============================================================================
    const addDescargoElectrico = () => {
        const numAleatorio = Math.floor(Math.random() * 999999) + 1;
        setDescargosElectricos([...descargosElectricos, {
            num_consignacion: numAleatorio,
            id_item: '', activo: '', centro_cargas: '', ubicacion: '', tension: '', descripcion: '',
            textoBusqueda: '', mostrarDesplegable: false
        }]);
    };

    const removeDescargoElectrico = (idx) => {
        setDescargosElectricos(descargosElectricos.filter((_, i) => i !== idx));
    };

    const handleFilaDescargoChange = (idx, texto) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx].textoBusqueda = texto;
        nuevasFilas[idx].mostrarDesplegable = texto.length >= 2;
        // Si borra el texto, limpiamos el descargo seleccionado
        if (texto === '') {
            nuevasFilas[idx].activo = '';
            nuevasFilas[idx].centro_cargas = '';
            nuevasFilas[idx].ubicacion = '';
            nuevasFilas[idx].tension = '';
            nuevasFilas[idx].descripcion = '';
        }
        setDescargosElectricos(nuevasFilas);
    };

    const toggleDescargoDesplegable = (idx, visible) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx].mostrarDesplegable = visible && nuevasFilas[idx].textoBusqueda.length >= 2;
        setDescargosElectricos(nuevasFilas);
    };

    const seleccionarElementoDescargoElectrico = (idx, elemento) => {
        const nuevasFilas = [...descargosElectricos];
        nuevasFilas[idx] = {
            ...nuevasFilas[idx],
            id_item: elemento.id_item,
            activo: elemento.activo,
            centro_cargas: elemento.centro_cargas || 'S/C',
            ubicacion: elemento.ubicacion || 'S/U',
            tension: elemento.tension,
            descripcion: elemento.descripcion || '',
            textoBusqueda: elemento.activo, // Dejamos el Tag visible en el input
            mostrarDesplegable: false // Cerramos su desplegable
        };
        setDescargosElectricos(nuevasFilas);
    };


    // ============================================================================
    // FUNCIONES: GESTIÓN DE RECURSOS Y TRABAJOS PREVIOS
    // ============================================================================
    // Se ejecuta al marcar/desmarcar un checkbo
    const handleRecursoToggle = (cat, nombre, checked) => {
        // Busca si el recurso ya existía en el array
        const exists = recursos.find(r => r.categoria === cat && r.nombre_recurso === nombre);
        
        if (exists) {
            // Si ya existe, simplemente actualiza su estado (true/false)
            setRecursos(recursos.map(r => (r.categoria === cat && r.nombre_recurso === nombre) ? { ...r, valor_check: checked } : r));
        } else {
            // Si no existe, lo añade al array de recursos a guardar
            setRecursos([...recursos, { categoria: cat, nombre_recurso: nombre, valor_check: checked, detalle_texto: "" }]);
        }
    };

    const handleRecursoText = (cat, nombre, texto) => {
        setRecursos(recursos.map(r => 
            (r.categoria === cat && r.nombre_recurso === nombre) 
                ? { ...r, detalle_texto: texto } 
                : r
        ));
    };

    // ============================================================================
    // FUNCIONES: APLICAR PLANTILLA
    // ============================================================================
    // Rellena los diferentes apartados segun la plantilla dada.
    const handleAplicarPlantilla = (idPlantilla) => {
        setPlantillaActiva(idPlantilla);

        // Si elija la "vacia" quita todo lo rellenado
        if (idPlantilla === "vacio") {
            setSeleccionados([]);
            setRecursos([]);
            setMateriales([]);
            setFormData(prev => ({ 
                ...prev, 
                titulo: '',
                tipo_incidencia: 'PREVENTIVO',
                descripcion_trabajo: '',
                duracion_prevista_hours: '',
                operarios_previstos: ''
            }));
            return;
        }

        // Revisa plantillas del listado creado
        const plantilla = PLANTILLAS_PREDEFINIDAS.find(p => p.id === idPlantilla);
        if (!plantilla) return;

        // 1. Marca los Riesgos según el ID real de la base
        const nuevosRiesgosIds = catalogo
            .filter(item => plantilla.codigos_riesgos.includes(item.codigo))
            .map(item => item.id_item);
        
        setSeleccionados(nuevosRiesgosIds);

        // 2. Marca los Recursos/Energías
        const nuevosRecursos = plantilla.recursos.map(pr => ({
            categoria: pr.cat,
            nombre_recurso: pr.nom,
            valor_check: true,
            detalle_texto: pr.detalle || ""
        }));
        setRecursos(nuevosRecursos);

        // 3. Rellena los datos de cabecera
        if (plantilla.tipo_incidencia) {
            setFormData(prev => ({ 
                ...prev, 
                titulo: plantilla.titulo || '',
                tipo_incidencia: plantilla.tipo_incidencia,
                descripcion_trabajo: plantilla.descripcion_trabajo || '',
                duracion_prevista_hours: plantilla.duracion_prevista_hours,
                operarios_previstos: plantilla.operarios_previstos
            }));
        }

        // 4. Añade los Materiales/Herramientas
        if (plantilla.materiales && plantilla.materiales.length > 0) {
            const nuevosMateriales = plantilla.materiales.map(mat => ({
                descripcion: mat.descripcion || '',
                unidades: mat.unidades || '',
                almacen: mat.almacen || ''
            }));
            setMateriales(nuevosMateriales);
        } else {
            setMateriales([]);
        }
    };

    // ============================================================================
    // FUNCIONES: GESTIÓN DE TRABAJADORES (SUBCONTRATA)
    // ============================================================================
    // Añade una tarjeta de trabajador vacía con todas las habilidades en false
    const addTrabajador = () => {
        setTrabajadores([...trabajadores, {
            nombre: '', apellidos: '', empresa: '',
            carretilla_elevadora: false, carretilla_telescopica: false,
            plataforma_elevadora: false, puente_grua: false,
            espacios_confinados: false, baja_tension: false,
            alta_tension: false, recurso_preventivo: false,
            camion_pluma: false, grua: false,
            formacion_altura: false, otros: ''
        }]);
    };

    // Actualiza el dato de un trabajador específico (texto o checkbox)
    const updateTrabajador = (idx, field, val) => {
        const newT = [...trabajadores];
        newT[idx][field] = val;
        setTrabajadores(newT);
    };

    // ============================================================================
    // FUNCIONES: GESTIÓN DE FOTOS (Reducción de tamaño)
    // ============================================================================
    // Coge la foto de la cámara/galería y la reduce a 800px para no saturar el servidor
    const comprimirImagen = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // Convierte a Base64
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const MAX_WIDTH = 800;
                    const scaleSize = MAX_WIDTH / img.width;
                    canvas.width = MAX_WIDTH;
                    canvas.height = img.height * scaleSize;

                    // Dibuja la imagen en un lienzo invisible más pequeño
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    
                    // Extrae la imagen comprimida con calidad al 60%
                    const base64Reducido = canvas.toDataURL('image/jpeg', 0.6);
                    resolve(base64Reducido);
                };
            };
        });
    };

    // Elimina una imagen del array usando su índice
    const eliminarImagen = (indexToRemove) => {
        setImagenesBase64(prev => prev.filter((_, index) => index !== indexToRemove));
    };

    // ============================================================================
    // GUARDADO Con FIRMA
    // ============================================================================
    // Se ejecuta tras realizar la firma.
    const handleSaveWithSignature = async (signatureBase64) => {

        // Control de doble click
        if (estaGuardando) return;
        setSeEstaGuardando(true);

        const token = localStorage.getItem('userToken');
        
        try {
            const anexoFormateado = datosEscalera ? {
                ...datosEscalera,
                clasificacion: Array.isArray(datosEscalera.clasificacion) ? datosEscalera.clasificacion.join(', ') : (datosEscalera.clasificacion || ''),
                justificacion: Array.isArray(datosEscalera.justificacion) ? datosEscalera.justificacion.join(', ') : (datosEscalera.justificacion || '')
            } : null;
            // LIpiamos y hacemos tratamientos de datos de INT y Strings
            const payload = {
                ...formData,
                titulo: formData.titulo || "Sin título",
                id_st: formData.id_st || '',
                id_activo: formData.id_activo ? parseInt(formData.id_activo) : null,
                id_localizacion: formData.id_localizacion ? parseInt(formData.id_localizacion) : null,
                operarios_previstos: formData.operarios_previstos ? parseInt(formData.operarios_previstos) : null,
                duracion_prevista_hours: formData.duracion_prevista_hours ? parseInt(formData.duracion_prevista_hours) : null,
                dias_previstos: formData.dias_previstos ? parseInt(formData.dias_previstos) : 1,
                // Si la subcontrata no aplica, pasamos usuario a NULL.
                id_usuario_subcontrata: formData.interviene_subcontrata && formData.id_usuario_subcontrata 
                    ? parseInt(formData.id_usuario_subcontrata) 
                    : null,
                
                // Aseguramos que los IDS sean numeros.
                riesgos_seleccionados: seleccionados.map(id => ({
                    id_item_seguridad: parseInt(id),
                    observacion_riesgo: detallesRiesgos[id] || ""
                })),
                
                materiales, 
                recursos, 
                trabajadores, 
                imagenes: imagenesBase64,
                anexo_escalera: anexoFormateado,
                bloqueos_electricos: bloqueosElectricos.filter(b => b.activo !== ''),
                descargos_electricos: descargosElectricos.filter(d => d.activo !== '')
            };

            // Enviamos JSON para crear la HPT. Pasa a estdo creada
            const resHpt = await axios.post(`${API_URL}/api/hpt`, payload, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            if (archivosPendientes.length > 0) {
                for (const file of archivosPendientes) {
                    const formDataFile = new FormData();
                    formDataFile.append('file', file);
                    await axios.post(`${API_URL}/api/hpt/${resHpt.data.id_hpt}/subir-archivo`, formDataFile, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data' 
                        }
                    });
                }
            }

            // Tras crearla, obtenemos el id y mandamos la firma
            await axios.post(`${API_URL}/api/hpt/${resHpt.data.id_hpt}/firmar`, {
                firma_path: signatureBase64,
                es_sustituto: false
            }, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            // Si todo va correctamente volvemos a Dashboard
            navigate('/dashboard');

        } catch (err) { 
            // Restauramos el estado anterior, por si existe fallo en petición no nos quede bloqueado.
            setSeEstaGuardando(false);
            // Capturamos errores de ZOD del BackEnd
            console.error("❌ Error al crear HPT:", err.response?.data || err);
            
            const detalleError = err.response?.data?.detail;
            if (detalleError) {
                Swal.fire({
                    title: "Error de Validación",
                    text: `Error de validación en el formulario:\n${JSON.stringify(detalleError)}`,
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            } else {
                Swal.fire({
                    title: "Error al crear la HPT.",
                    text: "Revisa consola para ver más detalles.",
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            }
        }
    };

    // ============================================================================
    // GUARDADO SIN FIRMA
    // ============================================================================
    const handleSaveWithoutSignature = async () => {

        // Control de doble click
        if (estaGuardando) return;
        setSeEstaGuardando(true);

        const token = localStorage.getItem('userToken');
        
        try {
            const anexoFormateado = datosEscalera ? {
                ...datosEscalera,
                clasificacion: Array.isArray(datosEscalera.clasificacion) ? datosEscalera.clasificacion.join(', ') : (datosEscalera.clasificacion || ''),
                justificacion: Array.isArray(datosEscalera.justificacion) ? datosEscalera.justificacion.join(', ') : (datosEscalera.justificacion || ''),
                medioAutorizacion: datosEscalera.medioAutorizacion || ""
            } : null;
            const payload = {
                ...formData,
                titulo: formData.titulo || "Sin título",
                id_st: formData.id_st || '',
                id_activo: formData.id_activo ? parseInt(formData.id_activo) : null,
                id_localizacion: formData.id_localizacion ? parseInt(formData.id_localizacion) : null,
                operarios_previstos: formData.operarios_previstos ? parseInt(formData.operarios_previstos) : null,
                duracion_prevista_hours: formData.duracion_prevista_hours ? parseInt(formData.duracion_prevista_hours) : null,
                dias_previstos: formData.dias_previstos ? parseInt(formData.dias_previstos) : 1,
                id_usuario_subcontrata: formData.interviene_subcontrata && formData.id_usuario_subcontrata 
                    ? parseInt(formData.id_usuario_subcontrata) 
                    : null,
                riesgos_ids: seleccionados.map(id => parseInt(id)), 
                materiales, 
                recursos, 
                trabajadores, 
                imagenes: imagenesBase64,
                anexo_escalera: anexoFormateado,
                bloqueos_electricos: bloqueosElectricos.filter(b => b.activo !== ''),
                descargos_electricos: descargosElectricos.filter(d => d.activo !== '')
            };

            // Enviamos JSON para crear la HPT (Pasa a estado CREADA y pendiente de SOLICITANTE)
            const resHpt = await axios.post(`${API_URL}/api/hpt`, payload, { 
                headers: { Authorization: `Bearer ${token}` } 
            });

            // Subida de archivos asociados a esta HPT
            if (archivosPendientes.length > 0) {
                for (const file of archivosPendientes) {
                    const formDataFile = new FormData();
                    formDataFile.append('file', file);
                    await axios.post(`${API_URL}/api/hpt/${resHpt.data.id_hpt}/subir-archivo`, formDataFile, {
                        headers: { 
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data' 
                        }
                    });
                }
            }
            
            // Volvemos al Dashboard
            navigate('/dashboard');

        } catch (err) { 
            // Restauramos el estado anterior, por si existe fallo en petición no nos quede bloqueado.
            setSeEstaGuardando(false);
            console.error("❌ Error al guardar HPT sin firma:", err.response?.data || err);
            const detalleError = err.response?.data?.detail;
            if (detalleError) {
                Swal.fire({
                    title: "Error de Validación",
                    text: `Error de validación en el formulario:\n${JSON.stringify(detalleError)}`,
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            } else {
                Swal.fire({
                    title: "Fallo",
                    text: `Error al guardar la HPT:  ${err}.`,
                    icon: "error",
                    confirmButtonColor: '#003366'
                })
            }
        }
    };

    // Extrae categorias Unidas
    const categoriasSeguridad = [...new Set(catalogo.map(item => item.categoria))];
    
    // ============================================================================
    // RENDER (HTML/JSX)
    // ============================================================================
    return (
        <div className="container">
            {/* El onSubmit evalúa qué botón se pulsó gracias al estado accionSubmit */}
            <form onSubmit={(e) => { 
                e.preventDefault(); 
                if (accionSubmit === 'sign') {
                    setShowSignature(true); // Abre el lienzo de firmas
                } else {
                    handleSaveWithoutSignature(); // Guarda directo
                }
            }}>
                
                {/* --- CABECERA --- */}
                <div className="top-header">
                    <div className="d-flex align-center">
                        <span className="ptw-label">NUEVA HPT:</span>
                        <div className="ptw-badge">
                            <span style={{ fontSize: '20px' }}>📋</span> 
                            OT: {formData.ot_referencia || 'SIN ASIGNAR'}
                        </div>
                    </div>
                    <div className="header-actions">
                        <button type="submit" className="btn-save" onClick={() => setAccionSubmit('sign')}>
                            ✍️ Proceder a Firma
                        </button>
                        <button type="submit" className="btn-save" style={{ backgroundColor: '#1a237e' }} onClick={() => setAccionSubmit('save')}>
                            💾 Guardar sin Firma
                        </button>
                        <button type="button" onClick={() => navigate('/dashboard')} className="btn-close">Cancelar</button>
                    </div>
                </div>

                {/* --- DATOS GENERALES --- */}
                <div className="main-card">
                    <div className="card-header-internal">Información Base de Planificación</div>

                    {/* --- DESPLEGABLE DE PLANTILLAS --- */}
                    <div className="template-banner">
                        <span className="template-title">
                            CARGAR PLANTILLA PREDEFINIDA:
                        </span>
                        <select 
                            className="main-select template-select"
                            value={plantillaActiva} 
                            onChange={(e) => handleAplicarPlantilla(e.target.value)}
                        >
                            {PLANTILLAS_PREDEFINIDAS.map(p => (
                                <option key={p.id} value={p.id}>{p.nombre}</option>
                            ))}
                        </select>
                        <span className="template-note">
                            * Al elegir una plantilla se indicaran horas y operarios totales previstos, se dará una breve descripción y se marcarán automáticamente los riesgos, recursos habituales y materiales usados. Puedes modificarlos abajo.
                        </span>
                    </div>

                    <div className="row">
                        <div className="info-box flex-2">
                            <span className="info-label">TÍTULO</span>
                            <input 
                                type="text" 
                                required 
                                className="main-input" 
                                value={formData.titulo}
                                onChange={e => setFormData({...formData, titulo: e.target.value})} 
                            />
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">NÚMERO DE OT:</span>
                            <input type="text" required className="main-input" onChange={e => setFormData({...formData, ot_referencia: e.target.value})} />
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">ID ST:</span>
                            <input type="text" className="main-input" value={formData.id_st} onChange={e => setFormData({...formData, id_st: e.target.value})}/>
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">ZONA DE TRABAJO:</span>
                            <select required className="main-select" onChange={e => setFormData({...formData, id_localizacion: e.target.value})}>
                                <option value="">-- Seleccione Zona --</option>
                                {localizaciones.map(loc => <option key={loc.id_localizacion} value={loc.id_localizacion}>{loc.nombre_zona}</option>)}
                            </select>
                        </div>
                        <div className="info-box flex-1">
                            <span className="info-label">Tipo de Incidencia:</span>
                            <select 
                                required className="main-select" 
                                value={formData.tipo_incidencia} 
                                onChange={e => setFormData({...formData, tipo_incidencia: e.target.value})}
                            >
                                <option value="PREVENTIVO">PREVENTIVO</option>
                                <option value="CORRECTIVO">CORRECTIVO</option>
                                <option value="MODIFICACION">MODIFICACIÓN</option>
                            </select>
                        </div>
                    </div>

                    {/* SECCIÓN DEL BUSCADOR DE ACTIVOS (AUTOCOMPLETAR) */}
                    <div className="asset-section-hpt">
                        <div className="row">
                            <div className="info-box flex-1 relative"> 
                                <span className="info-label">CÓDIGO ACTIVO (Buscador):</span>
                                
                                <input 
                                    type="text" 
                                    className="main-input" 
                                    placeholder="Escriba código o nombre..."
                                    value={busquedaActivo}
                                    onChange={(e) => {
                                        const valor = e.target.value;
                                        buscarActivosEnServidor(valor);
                                        setMostrarDesplegable(valor.length >= 3);
                                        // Si borra el texto, reseteamos el activo seleccionado
                                        if (formData.id_activo) {
                                            setFormData({...formData, id_activo: '', den_act_descripcion: ''});
                                        }
                                    }}
                                    onFocus={() => setMostrarDesplegable(true)}
                                    // Se usa un timeout para que de tiempo a pulsar la opción antes de que desaparezca
                                    onBlur={() => setTimeout(() => setMostrarDesplegable(false), 200)}
                                />

                                {/* Lista flotante de resultados del buscador */}
                                {mostrarDesplegable && busquedaActivo.length >= 2 && (
                                    <ul className="autocomplete-list">
                                        {opcionesActivos.length > 0 ? (
                                            opcionesActivos.map(a => (
                                                <li 
                                                    key={a.id_activo} 
                                                    className="autocomplete-item"
                                                    onMouseDown={() => seleccionarActivo(a)} 
                                                >
                                                    <strong>{a.codigo_activo}</strong> <br/>
                                                    <span className="text-small text-muted">{a.denominacion}</span>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="autocomplete-item">No se encontraron activos...</li>
                                        )}
                                    </ul>
                                )}
                            </div>
                            
                            <div className="info-box flex-2 asset-display-box">
                                <span className="info-label">DENOMINACIÓN DEL EQUIPO:</span>
                                <div className="asset-name-text">
                                    {formData.den_act_descripcion || 'Seleccione un activo en el buscador...'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="info-grid">
                        <div className="info-box">
                            <span className="info-label">👥 OPERARIOS:</span>
                            <input type="number" min="1" required className="main-input" value={formData.operarios_previstos} onChange={e => setFormData({...formData, operarios_previstos: parseInt(e.target.value)})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">📅 FECHA:</span>
                            <input type="date" required className="main-input" value={formData.fecha_prevista} onChange={e => setFormData({...formData, fecha_prevista: e.target.value})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">🕒 HORARIO:</span>
                            <input type="text" placeholder="Ej: 08:00 - 16:00" required className="main-input" value={formData.horario_previsto} onChange={e => setFormData({...formData, horario_previsto: e.target.value})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">⏳ HORAS PREVISTAS:</span>
                            <input type="number" min="1" required className="main-input" value={formData.duracion_prevista_hours} onChange={e => setFormData({...formData, duracion_prevista_hours: parseInt(e.target.value)})} />
                        </div>
                        <div className="info-box">
                            <span className="info-label">📅 DURACIÓN DÍAS:</span>
                            <input type="text" placeholder="Ej: 1" required className="main-input" value={formData.dias_previstos} onChange={e => setFormData({...formData, dias_previstos: e.target.value})} />
                        </div>
                    </div>

                    <div className="description-container">
                        <span className="info-label">DESCRIPCIÓN DE LAS TAREAS:</span>
                        <textarea rows="3" required className="main-textarea" value={formData.descripcion_trabajo} onChange={e => setFormData({...formData, descripcion_trabajo: e.target.value})} />
                    </div>

                   {/* SECCIÓN DEL BUSCADOR DE Usuarios Recurso Preventivo (AUTOCOMPLETAR) */}
                    <div className="asset-section-hpt">
                        <div className="row">
                            <div className="info-box flex-1 relative"> 
                                <span className="info-label">🛡️ NOMBRE DEL RECURSO PREVENTIVO:</span>
                                
                                <input 
                                    type="text" 
                                    className="main-input" 
                                    placeholder="Escriba el nombre del rol o grupo.."
                                    value={busquedaUsuarios}
                                    onChange={(e) => {
                                        buscarUsuariosServidor(e.target.value);
                                        setMostrarDesplegableUsuarios(true);
                                        // Si borra el texto, reseteamos el activo seleccionado
                                        if (formData.usuarios) {
                                            setFormData({...formData, preventivos: []});
                                        }
                                    }}
                                    onFocus={() => setMostrarDesplegableUsuarios(true)}
                                    // Se usa un timeout para que de tiempo a pulsar la opción antes de que desaparezca
                                    onBlur={() => setTimeout(() => setMostrarDesplegableUsuarios(false), 200)}
                                />

                                {/* Lista flotante de resultados del buscador */}
                                {mostrarDesplegableUsuarios && busquedaUsuarios.length >= 2 && (
                                    <ul className="autocomplete-list">
                                        {opcionesUsuarios.length > 0 ? (
                                            opcionesUsuarios.map((g, index) => (
                                                <li 
                                                    key={`${g.grupo}-${index}`}
                                                    className="autocomplete-item"
                                                    onMouseDown={() => seleccionarListaUsuarios(g)}
                                                >
                                                    <strong>Grupo: {g.grupo}</strong>
                                                    <br/>
                                                    <span className="text-small text-muted" style={{ wordBreak: 'break-all' }}>
                                                        {g.lista_usuarios}
                                                    </span>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="autocomplete-item">No se encontraron usuarios...</li>
                                        )}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* SECCIÓN DE FOTOGRAFÍAS */}
                    <div className="mt-20">
                        <h3 className="section-title">📸 Fotografías de la HPT</h3>

                        <input type="file" accept="image/*" multiple onChange={async (e) => {
                                const archivos = Array.from(e.target.files);
                                // Comprime todas las fotos seleccionadas a la vez
                                const base64Array = await Promise.all(archivos.map(file => comprimirImagen(file)));
                                setImagenesBase64(prev => [...prev, ...base64Array]);
                            }} 
                        />

                        <div className="photo-preview-container">
                        {imagenesBase64.map((imgBase64, index) => (
                            <div key={index} className="relative">
                                <img 
                                    src={imgBase64} 
                                    alt="preview" 
                                    className="img-preview-edit"
                                />
                                {/* Botón rojo de borrar superpuesto a la imagen */}
                                <button 
                                    type="button"
                                    onClick={() => eliminarImagen(index)}
                                    className="btn-delete-img"
                                >
                                    X
                                </button>
                            </div>
                        ))}
                        </div>
                    </div>
                </div>

                {/* SECCIÓN DE DOCUMENTOS ADJUNTOS */}
                <div className="document-section">
                    <h3 className="section-title">
                        📎 Documentos Adjuntos (PDF, Excel, Word)
                    </h3>
                    <div className="document-upload-zone mt-10">
                        <input
                            type="file"
                            accept=".pdf,.xls,.xlsx,.doc,.docx"
                            multiple
                            onChange={(e) => {
                                const files = Array.from(e.target.files);
                                setArchivosPendientes(prev => [...prev, ...files]);
                            }}
                        />
                    </div>

                    {archivosPendientes.length > 0 && (
                        <div className="document-list">
                            {archivosPendientes.map((file, index) => (
                                <div key={index} className="document-item document-item-pending">
                                    <div className="document-info">
                                        <span className="document-icon">⏳</span>
                                        <span>{file.name} <em className="text-pending-status">({(file.size / 1024 / 1024).toFixed(2)} MB)</em></span>
                                    </div>
                                    <button type="button" onClick={() => setArchivosPendientes(prev => prev.filter((_, i) => i !== index))} className="btn-delete-file">
                                        X Quitar
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* --- BLOQUES ACOORDEONES --- */}
                
                {/* MATERIALES */}
                <ExpandableCard title="Repuestos y Herramientas" icon="🔧">
                    <table className="table">
                        <thead>
                            <tr className="table-header">
                                <th className="th">Descripción</th>
                                <th className="th">UD</th>
                                <th className="th">Almacén</th>
                                <th className="th">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {materiales.map((m, idx) => (
                                <tr key={idx}>
                                    <td className="td"><input className="borderless-input" value={m.descripcion} onChange={e => updateMaterial(idx, 'descripcion', e.target.value)} /></td>
                                    <td className="td"><input className="borderless-input" value={m.unidades} onChange={e => updateMaterial(idx, 'unidades', e.target.value)} /></td>
                                    <td className="td"><input className="borderless-input" value={m.almacen} onChange={e => updateMaterial(idx, 'almacen', e.target.value)} /></td>
                                    <td className="td text-center" onClick={() => setMateriales(materiales.filter((_,i) => i !== idx))}>❌</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button type="button" onClick={addMaterial} className="add-btn">+ Añadir Fila</button>
                </ExpandableCard>

                {/* RECURSOS Y ENERGÍAS */}
                <ExpandableCard title="Recursos, Energías y Trabajos Previos" icon="⚡">
                    {/* Itera sobre el objeto CONFIG_RECURSOS creando una sección por cada categoría */}
                    {Object.entries(CONFIG_RECURSOS).map(([categoria, items]) => (
                        <div key={categoria} className="mb-20">
                            <div className="res-cat-title">{categoria}</div>
                            <div className="grid-checks">
                                {items.map(item => {
                                    // Buscamos el recurso completo para saber si está checkeado y si tiene texto guardado
                                    const recursoEncontrado = recursos.find(r => r.categoria === categoria && r.nombre_recurso === item);
                                    const isChecked = recursoEncontrado ? recursoEncontrado.valor_check : false;
                                    const textoDetalle = recursoEncontrado ? recursoEncontrado.detalle_texto : '';
                                    
                                    return (
                                        <div key={item} style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                            <label className={`hab-item ${isChecked ? 'checked' : ''}`}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={isChecked}
                                                    onChange={(e) => handleRecursoToggle(categoria, item, e.target.checked)} 
                                                />
                                                {item}
                                            </label>

                                            {/* Si es 'Químicos' y está marcado, mostramos la caja de texto */}
                                            {item === 'Químicos' && isChecked && (
                                                <input 
                                                    type="text" 
                                                    className="main-input res-text-input" 
                                                    placeholder="Especifique qué químico..." 
                                                    value={textoDetalle}
                                                    onChange={(e) => handleRecursoText(categoria, item, e.target.value)}
                                                    required
                                                />
                                            )}

                                            {/* Si es 'Escalera' y está marcado, mostramos el botón flotante */}
                                            {item === 'Escalera' && isChecked && (
                                                <div style={{ marginTop: '5px', marginLeft: '25px' }}>
                                                    <button 
                                                        type="button" 
                                                        className="btn-save" 
                                                        style={{ 
                                                            backgroundColor: datosEscalera ? '#2e7d32' : '#f57c00', // Verde si está relleno, Naranja si falta
                                                            padding: '6px 12px', fontSize: '12px' 
                                                        }}
                                                        onClick={() => setShowEscaleraModal(true)}
                                                    >
                                                        📄 {datosEscalera ? 'Anexo Escalera (Completado)' : 'Rellenar Anexo Escalera'}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                    {/* DETECTOR DE ENCLAVAMIENTO ELÉCTRICO */}
                    {recursos.some(r => r.categoria === 'TRABAJOS PREVIOS' && r.nombre_recurso === 'Enclavamiento eléctrico' && r.valor_check) && (
                        <div className="loto-wrapper">
                            <div className="loto-title-panel">⚡ Bloqueo Eléctrico</div>
                            
                            <table className="table">
                                <thead>
                                    <tr className="table-header">
                                        <th className="th" style={{ width: '30%' }}>Tag Activo (Buscador Predictivo)</th>
                                        <th className="th" style={{ width: '20%' }}>Centro de Cargas</th>
                                        <th className="th" style={{ width: '30%' }}>Panel / Celda / Maniobra</th>
                                        <th className="th" style={{ width: '10%' }}>Tensión</th>
                                        <th className="th" style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {bloqueosElectricos.map((bloqueo, idx) => (
                                        <tr key={idx}>
                                            {/* Buscador de Tags Eléctricos con coincidencia múltiple */}
                                            <td className="td relative">
                                                <input 
                                                    type="text" 
                                                    className="main-input w-100 loto-yellow-input"
                                                    placeholder="Teclee Tag Eléctrico (Ej: 00-V...)"
                                                    value={bloqueo.textoBusqueda}
                                                    onChange={(e) => handleFilaBloqueoChange(idx, e.target.value)}
                                                    onFocus={() => toggleBloqueoDesplegable(idx, true)}
                                                    // Retardo en el blur para dejar que el onMouseDown del click procese antes de ocultar
                                                    onBlur={() => setTimeout(() => toggleBloqueoDesplegable(idx, false), 200)}
                                                />

                                                {/* Desplegable Predictivo sobre el estado local 'electricos' */}
                                                {bloqueo.mostrarDesplegable && (
                                                    <ul className="autocomplete-list loto-dropdown">
                                                        {electricosBloqueo.filter(e => 
                                                            e.activo.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase()) ||
                                                            (e.descripcion && e.descripcion.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase()))
                                                        ).length > 0 ? (
                                                            electricosBloqueo
                                                                .filter(e => 
                                                                    e.activo.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase()) ||
                                                                    (e.descripcion && e.descripcion.toLowerCase().includes(bloqueo.textoBusqueda.toLowerCase()))
                                                                )
                                                                .map(elem => (
                                                                    <li 
                                                                        key={elem.id_item} 
                                                                        className="autocomplete-item loto-dropdown-item"
                                                                        onMouseDown={() => seleccionarElementoBloqueoElectrico(idx, elem)}
                                                                    >
                                                                        <strong>{elem.activo}</strong> — <span className="loto-cc-tag">{elem.centro_cargas}</span>
                                                                        <div className="loto-muted-text">{elem.ubicacion} {elem.descripcion ? `(${elem.descripcion})` : ''} — <strong>{elem.tension}V</strong></div>
                                                                    </li>
                                                                ))
                                                        ) : (
                                                            <li className="autocomplete-item text-pending-status">No se encontraron elementos en el catálogo...</li>
                                                        )}
                                                    </ul>
                                                )}
                                            </td>

                                            {/* Campos automáticos en modo lectura */}
                                            <td className="td loto-readonly">{bloqueo.centro_cargas}</td>
                                            <td className="td loto-readonly">
                                                <div>{bloqueo.ubicacion}</div>
                                                {bloqueo.descripcion && <small className="text-muted-small">{bloqueo.descripcion}</small>}
                                            </td>
                                            <td className="td loto-readonly text-center font-bold">
                                                {bloqueo.tension ? `${bloqueo.tension} V` : ''}
                                            </td>

                                            {/* Botón de Borrado de fila */}
                                            <td className="td text-center">
                                                <button type="button" className="del-btn" onClick={() => removeBloqueoElectrico(idx)}>Quitar</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            
                            <button type="button" className="add-btn" style={{ backgroundColor: '#2e7d32' }} onClick={addBloqueoElectrico}>
                                ⚡+ Añadir Bloqueo Electrico
                            </button>
                        </div>
                    )}

                    {/* DETECTOR DE ENCLAVAMIENTO ELÉCTRICO */}
                    {recursos.some(r => r.categoria === 'TRABAJOS PREVIOS' && r.nombre_recurso === 'Descargo eléctrico' && r.valor_check) && (
                        <div className="loto-wrapper">
                            <div className="loto-title-panel">⚡ Descargo Eléctrico</div>
                            
                            <table className="table">
                                <thead>
                                    <tr className="table-header">
                                        <th className="th" style={{ width: '30%' }}>Tag Activo (Buscador Predictivo)</th>
                                        <th className="th" style={{ width: '20%' }}>Centro de Cargas</th>
                                        <th className="th" style={{ width: '30%' }}>Panel / Celda / Maniobra</th>
                                        <th className="th" style={{ width: '10%' }}>Tensión</th>
                                        <th className="th" style={{ width: '10%', textAlign: 'center' }}>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {descargosElectricos.map((descargo, idx) => (
                                        <tr key={idx}>
                                            {/* Buscador de Tags Eléctricos con coincidencia múltiple */}
                                            <td className="td relative">
                                                <input 
                                                    type="text" 
                                                    className="main-input w-100 loto-yellow-input"
                                                    placeholder="Teclee Tag Eléctrico (Ej: 00-V...)"
                                                    value={descargo.textoBusqueda}
                                                    onChange={(e) => handleFilaDescargoChange(idx, e.target.value)}
                                                    onFocus={() => toggleDescargoDesplegable(idx, true)}
                                                    // Retardo en el blur para dejar que el onMouseDown del click procese antes de ocultar
                                                    onBlur={() => setTimeout(() => toggleDescargoDesplegable(idx, false), 200)}
                                                />

                                                {/* Desplegable Predictivo sobre el estado local 'electricos' */}
                                                {descargo.mostrarDesplegable && (
                                                    <ul className="autocomplete-list loto-dropdown">
                                                        {electricosDescargo.filter(e => 
                                                            e.activo.toLowerCase().includes(descargo.textoBusqueda.toLowerCase()) ||
                                                            (e.descripcion && e.descripcion.toLowerCase().includes(descargo.textoBusqueda.toLowerCase()))
                                                        ).length > 0 ? (
                                                            electricosDescargo
                                                                .filter(e => 
                                                                    e.activo.toLowerCase().includes(descargo.textoBusqueda.toLowerCase()) ||
                                                                    (e.descripcion && e.descripcion.toLowerCase().includes(descargo.textoBusqueda.toLowerCase()))
                                                                )
                                                                .map(elem => (
                                                                    <li 
                                                                        key={elem.id_item} 
                                                                        className="autocomplete-item loto-dropdown-item"
                                                                        onMouseDown={() => seleccionarElementoDescargoElectrico(idx, elem)}
                                                                    >
                                                                        <strong>{elem.activo}</strong> — <span className="loto-cc-tag">{elem.centro_cargas}</span>
                                                                        <div className="loto-muted-text">{elem.ubicacion} {elem.descripcion ? `(${elem.descripcion})` : ''} — <strong>{elem.tension}V</strong></div>
                                                                    </li>
                                                                ))
                                                        ) : (
                                                            <li className="autocomplete-item text-pending-status">No se encontraron elementos en el catálogo...</li>
                                                        )}
                                                    </ul>
                                                )}
                                            </td>

                                            {/* Campos automáticos en modo lectura */}
                                            <td className="td loto-readonly">{descargo.centro_cargas}</td>
                                            <td className="td loto-readonly">
                                                <div>{descargo.ubicacion}</div>
                                                {descargo.descripcion && <small className="text-muted-small">{descargo.descripcion}</small>}
                                            </td>
                                            <td className="td loto-readonly text-center font-bold">
                                                {descargo.tension ? `${descargo.tension} V` : ''}
                                            </td>

                                            {/* Botón de Borrado de fila */}
                                            <td className="td text-center">
                                                <button type="button" className="del-btn" onClick={() => removeDescargoElectrico(idx)}>Quitar</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            
                            <button type="button" className="add-btn" style={{ backgroundColor: '#2e7d32' }} onClick={addDescargoElectrico}>
                                ⚡+ Añadir Descargo Electrico
                            </button>
                        </div>
                    )}
                </ExpandableCard>
                
                {/* MATRIZ DE RIESGOS */}
                <ExpandableCard title="Matriz de Riesgos y Medidas" icon="🚨">
                    {categoriasSeguridad.map(cat => (
                        <div key={cat} className="mb-20">
                            <div className="res-cat-title">{cat}</div>
                            <div className="grid-checks">
                                {/* Filtra el catálogo para pintar solo los ítems de esta categoría */}
                                {catalogo.filter(i => i.categoria === cat).map(item => {
                                    const isSelected = seleccionados.includes(item.id_item);
                                    
                                    // Asignamos la clase correcta dependiendo de si es rojo (Riesgo) o verde (Medida Correctiva)
                                    let badgeClass = 'risk-badge';
                                    if (isSelected) {
                                        badgeClass += item.es_riesgo ? ' checked-risk' : ' checked-measure';
                                    }
                                    
                                    const esComodinMaquinaria = item.codigo === '10007';

                                    return (
                                        <div key={item.id_item}>
                                            <label className={badgeClass}>
                                                <input 
                                                    type="checkbox" 
                                                    checked={isSelected} 
                                                    onChange={() => {
                                                        if (isSelected) {
                                                            setSeleccionados(seleccionados.filter(i => i !== item.id_item));
                                                            const nuevosDetalles = { ...detallesRiesgos };
                                                            delete nuevosDetalles[item.id_item];
                                                            setDetallesRiesgos(nuevosDetalles);
                                                        } else {
                                                            setSeleccionados([...seleccionados, item.id_item]);
                                                        }
                                                    }} 
                                                />
                                                <span className={`text-small ${item.es_riesgo ? 'text-risk' : 'text-measure'}`}>
                                                    <strong>{item.codigo}</strong> - {item.descripcion}
                                                </span>
                                            </label>
                                            {isSelected && esComodinMaquinaria && (
                                                <input 
                                                    type="text" 
                                                    className="main-input res-text-input" 
                                                    placeholder="Especifique máquina: ej. Tractor" 
                                                    value={detallesRiesgos[item.id_item] || ''}
                                                    onChange={(e) => setDetallesRiesgos({
                                                        ...detallesRiesgos,
                                                        [item.id_item]: e.target.value
                                                    })}
                                                    required 
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </ExpandableCard>
                
                {/* ASIGNACIÓN DE EMPRESA SUBCONTRATADA */}
                <div className="subcontractor-box">
                    <label className="d-flex align-center gap-10" style={{ fontWeight: 'bold' }}>
                        <input type="checkbox" checked={formData.interviene_subcontrata} onChange={(e) => setFormData({...formData, interviene_subcontrata: e.target.checked})} /> 
                        ¿INTERVIENE EMPRESA SUBCONTRATADA?
                    </label>
                    {formData.interviene_subcontrata && (
                        <select required className="main-select w-100 mt-10" onChange={(e) => setFormData({...formData, id_usuario_subcontrata: parseInt(e.target.value)})}>
                            <option value="">-- Asignar Responsable --</option>
                            {/* Filtramos a futuro aquí si queremos mostrar solo usuarios rol "Subcontrata" */}
                            {usuarios.map(u => <option key={u.id_usuario} value={u.id_usuario}>{u.nombre} {u.apellidos}</option>)}
                        </select>
                    )}
                </div>

                {/* TRABAJADORES SUBCONTRATA */}
                {formData.interviene_subcontrata && (
                    <ExpandableCard title="Trabajadores de Subcontrata" icon="👷">
                        <div className="worker-grid">
                            {trabajadores.map((t, idx) => (
                                <div key={idx} className="worker-card">
                                    <div className="worker-header">
                                        <strong>TRABAJADOR #{idx + 1}</strong>
                                        <button type="button" onClick={() => setTrabajadores(trabajadores.filter((_, i) => i !== idx))} className="del-btn">Eliminar</button>
                                    </div>
                                    <div className="row">
                                        <input className="main-input flex-1" placeholder="Nombre" value={t.nombre} onChange={e => updateTrabajador(idx, 'nombre', e.target.value)} />
                                        <input className="main-input flex-1" placeholder="Apellidos" value={t.apellidos} onChange={e => updateTrabajador(idx, 'apellidos', e.target.value)} />
                                    </div>
                                    <div className="row">
                                        <input className="main-input w-100" placeholder="Empresa Subcontrata..." value={t.empresa || ''} onChange={e => updateTrabajador(idx, 'empresa', e.target.value)} />
                                    </div>
                                    {/* Listado de Habilitaciones del trabajador */}
                                    <div className="hab-grid-full">
                                        {[
                                            {id: 'carretilla_elevadora', label: 'Carretilla Elev.'},
                                            {id: 'carretilla_telescopica', label: 'C. Telescópica'},
                                            {id: 'plataforma_elevadora', label: 'Pla. Elevadora'},
                                            {id: 'puente_grua', label: 'Puente Grúa'},
                                            {id: 'espacios_confinados', label: 'Esp. Confinados'},
                                            {id: 'formacion_altura', label: 'F. Altura'},
                                            {id: 'baja_tension', label: 'Baja Tensión'},
                                            {id: 'alta_tension', label: 'Alta Tensión'},
                                            {id: 'camion_pluma', label: 'Camión Pluma'},
                                            {id: 'grua', label: 'Grúa'},
                                            {id: 'recurso_preventivo', label: 'RECURSO PREVENTIVO', special: true}
                                        ].map(hab => (
                                            <label key={hab.id} className={`hab-item ${hab.special ? 'special' : ''}`}>
                                                <input type="checkbox" checked={t[hab.id]} onChange={e => updateTrabajador(idx, hab.id, e.target.checked)} />
                                                {hab.label}
                                            </label>
                                        ))}
                                        <input className="main-input span-2" placeholder="Otros certificados..." value={t.otros} onChange={e => updateTrabajador(idx, 'otros', e.target.value)} />
                                    </div>
                                </div>
                            ))}
                        </div>
                        <button type="button" onClick={addTrabajador} className="add-btn">+ Añadir Trabajador</button>
                    </ExpandableCard>
                )}

                

            </form>
            
            {/* --- COMPONENTE FLOTANTE: PAD DE FIRMA --- */}
            {/* Si showSignature es true, la pantalla se oscurece y sale el lienzo para firmar con el dedo/ratón */}
            {showSignature && <SignaturePad onSave={handleSaveWithSignature} onCancel={() => setShowSignature(false)} />}
            {/* --- COMPONENTE FLOTANTE: ANEXO ESCALERA --- */}
            {showEscaleraModal && (
                <PermisoEscalera 
                    datosPrevios={datosEscalera} 
                    usuarioActual={currentUser.user}
                    onSave={(data) => {
                        setDatosEscalera(data);
                        setShowEscaleraModal(false);
                    }} 
                    onCancel={() => setShowEscaleraModal(false)} 
                />
            )}
        </div>
    );
};

export default CreateHPTScreen;